import _ from 'lodash'

import { getTranslatedString, Workspace } from '@skinsoft/types'

export const name = (workspace: Workspace, locale: string) => getTranslatedString(_.get(workspace, 'name'), locale)

export const type = (workspace: Workspace): string | undefined | null => {
    return _.get(workspace, 'type')
} 